import { useEffect, useState } from "react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Dialog, IconButton } from "@mui/material";
import "./ReportingDialog.css";
import "../Components/Components.css";
import Loader from "../Components/Loader";

const ReportingDialog = ({
  dashboardName,
  isOpen,
  selectedURL,
  setIsReportingDialogShown,
  setSelectedDashboardName,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let iframe = document.getElementById("grafanaDashboard");

    // If using API Token
    let apiToken = "Bearer glsa_zCrxbDopnVpzmNd26uluy9Ne1I8hZXQV_b535c561";

    if (iframe) {
      iframe.onload = function () {
        iframe.contentWindow.postMessage(
          { message: "set_token", token: apiToken },
          "*"
        );
      };
    }
  }, [isOpen]);

  const handleClose = () => {
    setSelectedDashboardName("");
    setIsReportingDialogShown(false);
    setIsLoading(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog reporting-dialog"
      fullWidth
      maxWidth="xl"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <form method="post" onSubmit={handleSubmit}>
          <div className="dialog-content">
            <IconButton className="close-button" onClick={handleClose}>
              <CloseOutlined />
            </IconButton>

            <h2 className="title">
              {dashboardName ? dashboardName : "Reporting"}
            </h2>

            <div className="iframe-container">
              {isLoading && <Loader />}

              <iframe
                id="grafanaDashboard"
                width="100%"
                height="600"
                frameBorder="0"
                title="reporting"
                src={`${selectedURL}&auth_token=${localStorage.getItem(
                  "token"
                )}`}
              />
            </div>

            <section className="buttons">
              <button className="cancel" type="button" onClick={handleClose}>
                Back
              </button>
            </section>
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default ReportingDialog;
